export default {
    title: 'Assistente Astrológico',
    assistantRoute: 'assistente-astrologico',

    pageTitle: {
        assistant: 'Assistente',
        default: 'ASSISTENTE ASTROLÓGICO',
        history: 'HISTÓRICO DE PERGUNTAS',
        ots: 'PERGUNTAS AVULSAS'
    },

    maintenance: {
        title: 'Estamos em manutenção!',
        text: 'O Orbia está em manutenção no momento, lamentamos pelo inconveniente. Volte mais tarde para tirar suas dúvidas sobre astrologia!'
    },

    introduction: {
        button: 'Vamos lá!',
        mainText: {
            common: '<p>Parabéns, {userName}! Seja bem-vind{article} à fase de testes do Orbia, o assistente inteligente do Astrolink que proporciona insights e orientações específicas para suas dúvidas e curiosidades.</p>',
            subscriber:
                '<p>Você poderá fazer cinco perguntas por dia. Seus créditos serão renovados à meia-noite e não se acumularão.</p>',
            nonSubscriber:
                '<p>Você poderá fazer duas perguntas no primeiro dia para pegar o jeito, depois ganhará uma pergunta diária. Seu crédito será renovado à meia-noite e não se acumulará.</p>'
        },

        bubbleIntroduction: {
            presentation: 'Olá {userName}, eu sou o Orbia, o assistente de IA do Astrolink!',
            instructions:
                'Podemos conversar sobre astrologia e vários outros assuntos relacionados.\n\nO que você quer saber?'
        }
    },

    conversation: {
        freeQuestions: {
            plural: 'Você ganhou {count} perguntas grátis',
            singular: 'Resta 1 pergunta grátis',
            blocked: 'Clique para liberar mais perguntas'
        },
        authorLabel: 'Orbia',
        send: 'Enviar',
        stop: 'Parar',
        retry: 'Tentar novamente',
        stopped: 'Resposta interrompida.',
        thinking: 'Pensando',
        backToBottom: 'Ir para o fim',

        welcome: {
            greeting: 'Olá, {userName}',
            prompt: 'O que você gostaria de explorar no seu mapa?'
        },

        error: `
            <p>Parece que Mercúrio resolveu entrar em retrogradação mais cedo! 😅 Estamos com dificuldades para processar sua solicitação.</p>
            <p>Por favor, revise as informações e tente novamente clicando no botão de envio.</p>
            <p>Se o problema persistir, tente novamente mais tarde ou entre em contato com nossa equipe:</p>
            <p>👉 <a href="https://suporte.astrolink.com.br/hc/pt-br/requests/new">Equipe Astrolink</a></p>
            <p>Agradecemos sua paciência! ✨</p>
        `,

        informative: {
            reportAnError: 'Reportar um erro',
            howItWorks: 'Como o Orbia funciona?',
            zendesk: 'zendesk_login?return_to=https://suporte.astrolink.com.br/hc/pt-br/requests/new',
            enjoySubscriber: 'Ser premium te garante 5 créditos de perguntas todos os dias! Aproveite o assistente! 🧞‍♂️',
            becomePremium:
                'Todos os dias seu crédito de pergunta do Orbia é renovado. <a href="{url}">Torne-se Premium</a> para receber 5 créditos todos os dias 🧞‍♂️'
        },

        introduction: {
            text: `
                Olá {userName}! Eu sou o Orbia, assistente do Astrolink. 
                Me pergunte qualquer coisa sobre seu mapa astral ou astrologia em geral e darei o meu melhor para te responder.
            `,
            title: 'O que você quer saber?',
            subtitle: 'Quanto mais detalhes a sua pergunta tiver, mais aprofundada será a minha resposta.'
        },

        questionBox: {
            inputPlaceholder: {
                regular: 'Digite sua pergunta!',
                noQuestion: {
                    plural: 'Digite sua pergunta! Você possui {creditsCount} créditos.',
                    singular: 'Digite sua pergunta! Você possui 1 crédito.'
                },

                feedback: 'Seu feedback é opcional e muito importante'
            },

            button: {
                back: 'Voltar',
                restart: 'Recomeçar',
                subscribe: 'Assinar para mais perguntas'
            },

            creditsLabel: {
                haveCredits: {
                    singular: 'Você ainda tem 1 pergunta hoje 😉',
                    plural: 'Você ainda tem {creditsCount} perguntas hoje 😉'
                },

                noCredits:
                    'Você usou todas as suas perguntas de boas vindas 😕 Veja as opcões de pacotes para poder continuar usando o Orbia:',
                noCreditsSub: 'Você atingiu seu limite de perguntas do mês ⏳. Aguarde a renovação ou ',
                noCreditsLink: 'adquira perguntas avulsas!'
            },

            blocked: `<strong>Atenção!</strong>
                Você ainda não informou seu horário de nascimento, isso compromete a precisão das informações sobre alguns aspectos do seu mapa.
                Para resolver esse problema, <a href={profileUrl}>atualize seus dados</a> e informe o horário de nascimento.
            `
        },

        creditsText: {
            plural: 'Vamos lá! Você pode fazer {credits} perguntas hoje',
            singular: 'Vamos lá! Você pode fazer 1 pergunta hoje'
        },

        suggestion: {
            label: 'Sugestões',
            title: 'Sugestões de perguntas',
            toBecome: 'Sugestões para Começar',
            subtitle: 'Não sabe o que me perguntar? Toque em uma dessas sugestões para começar:'
        },

        feedback: {
            utilAnswer: {
                mainMessage: 'Minha resposta te ajudou?',

                badAnswer: {
                    withCredits:
                        'Obrigado, com a sua ajuda vou melhorar minhas respostas. Se desejar recomeçar, use o botão Voltar abaixo.',
                    withoutCredits: 'Obrigado, com a sua ajuda vou melhorar minhas respostas.'
                },

                goodAnswer: {
                    withCredits:
                        'Que bom! Se tiver mais perguntas, toque no botão recomeçar. Ficarei feliz em ajudar novamente!',
                    withoutCredits: 'Que bom! Espero poder te ajudar novamente.'
                },

                button: {
                    yes: 'Sim',
                    no: 'Não'
                }
            },

            otherTelMeMore: 'Pode detalhar seu problema?',

            options: {
                mainMessage:
                    'Sinto muito! Para ajudar no meu treinamento, pode me dizer qual problema você identificou na minha resposta?',
                first: 'Informações incorretas sobre astrologia',
                second: 'Respondi uma pergunta diferente da que você me fez',
                third: 'Minha resposta não foi clara o suficiente',
                fourth: 'Outro problema'
            }
        },

        example: {
            special: {
                title: 'Especial 2026',
                description: 'Um convite para descobrir algo novo sobre você',
                example1: 'Quais são as previsões de 2026 para meu mapa?',
                example2: 'Como será minha vida amorosa em 2026?',
                example3: 'Quais previsões para minha vida profissional em 2026?',
                example4: 'Quais são os meses mais importantes para mim em 2026 e como aproveitá-los?',
                example5: 'O que o Tarot revela sobre minha vida em 2026?'
            },
            mercuryRetrograde: {
                title: 'Mercúrio Retrógrado',
                example1:
                    'Considerando meu mapa, quais serão os principais impactos de Mercúrio Retrógrado em Peixes na minha vida?',
                example2:
                    'De que maneira Mercúrio retrógrado em Peixes impacta minha vida profissional e nos meus planos de curto prazo?',
                example3:
                    'Mercúrio retrógrado em peixes pode trazer alguém do meu passado amoroso de volta? O que meu mapa astral revela sobre isso?',
                example4: 'Como Mercúrio retrógrado em Peixes afeta minha vida amorosa, segundo o meu mapa astral?',
                example5:
                    'Liste 3 oportunidades e 3 desafios que Mercúrio Retrógrado em Peixes pode trazer para o meu mapa.'
            },
            personality: {
                title: 'Personalidade',
                description: 'Entenda seus traços e potenciais',
                example1: 'De acordo com meu mapa astral, como as pessoas me veem e como posso aproveitar isso?',
                example2: 'Quais planetas são dominantes na minha personalidade?',
                example3:
                    'Quais são os aspectos mais desafiadores da minha personalidade segundo meu mapa astral e como trabalhar isso?',
                example4: 'O que minha tríade diz sobre mim?'
            },
            relationship: {
                title: 'Relacionamento',
                description: 'Explore vínculos e dinâmicas afetivas',
                example1: 'Me dê dicas para melhorar meus relacionamentos com base em meu mapa astral',
                example2: 'O que meu mapa astral diz sobre o tipo de parceiro ideal para mim?',
                example3: 'O que meu mapa fala sobre repetição de padrões em relacionamentos amorosos?',
                example4: 'O que meu mapa diz sobre casamento?'
            },
            career: {
                title: 'Carreira e Finanças',
                description: 'Direções profissionais e prosperidade',
                example1:
                    'De acordo com meu mapa astral, quais pontos preciso desenvolver para ter sucesso na vida profissional?',
                example2:
                    'O que meu Meio do Céu (MC) revela sobre minhas ambições e carreira? Como posso usar isso em meu favor?',
                example3: 'Qual é minha vocação? Me dê dicas práticas para entendê-la e exercê-la.',
                example4: 'De acordo com meu mapa, me dê 5 dicas fundamentais para prosperar financeiramente.'
            },
            spirituality: {
                title: 'Espiritualidade',
                description: 'Propósito, expansão e consciência',
                example1: 'Como posso me abrir mais para minha intuição usando a energia do meu mapa astral?',
                example2: 'Como posso superar medos espirituais e limitações internas com ajuda do meu mapa?',
                example3: 'Como posso alinhar minhas ações com meu propósito espiritual e alcançar mais equilíbrio?',
                example4:
                    'Quais são as melhores maneiras de praticar a espiritualidade no dia a dia, considerando minhas características astrológicas?'
            }
        }
    },

    howDidWork: {
        button: 'Explorar o Orbia',
        title: 'Como o Orbia funciona?',
        paragraph: `
            <p>Olá, {user}! Seja muito bem-vind{genderSuffix} ao Orbia, um assistente inteligente do Astrolink e fonte de conhecimento transdisciplinar, que proporciona insights e orientações específicas conforme suas dúvidas e curiosidades.</p>
            <p>Você foi especialmente selecionad{genderSuffix} para utilizar esta ferramenta no momento, mas para garantir uma experiência segura e informativa, é importante que você entenda um pouco sobre suas limitações além de outras informações importantes. Vamos lá!</p>
        `,

        accordions: {
            expectations: {
                title: 'Expectativas e Uso Responsável',
                content: `
                    <p>{user}, esta experiência interativa pode fornecer análises baseadas em Astrologia e está em constante desenvolvimento, o que significa que suas respostas e funcionalidades irão evoluir com o tempo. Desta forma, é crucial que você mantenha expectativas realistas quanto ao seu uso. Isto quer dizer que nem todas as respostas serão perfeitas e algumas funcionalidades podem ser limitadas por enquanto.</p>
                    <p>As respostas fornecidas, embora surpreendentes e muitas vezes incríveis, podem variar em precisão e não serem aplicáveis a todas as situações individuais. Inclusive, não substituem o rico conteúdo encontrado nas diversas áreas do site, seu julgamento pessoal e o aconselhamento de profissionais qualificados.</p>
                    <p>Use as informações fornecidas como insights e reflexões, mas não como uma verdade absoluta. Isso inclui evitar a dependência excessiva das previsões e análises para tomar decisões importantes.</p>
                    <p>O Orbia também pode cometer erros. É importante considerar esta informação em suas interações, usando o serviço de maneira consciente, responsável e ciente de suas limitações.</p>
                    <p>Caso tenha dúvidas ou feedbacks sobre esta área, não hesite em nos contatar através do nosso canal de atendimento <a href="/contato">contato@astrolink.com.br</a> ou reportar algum erro através deste link.</p>
                `
            },

            discovery: {
                title: 'Descobertas e conexões - Uma Nova Era!',
                content: `
                    <p>É interessante refletir também que estamos vivenciando um momento único na história humana, um período que promete revoluções em nosso entendimento e conexão com o Universo. Este é um tempo de despertar para descobertas, novas ideias, tecnologias, quebras de paradigma e um senso ampliado de comunidade e consciência coletiva, mas sem deixarmos de valorizar também nossa individualidade. É o eixo Aquário - Leão em ação, {user}!</p>
                    <p>A Astrologia, com sua sabedoria milenar, oferece uma janela para o entendimento do ser humano e seu lugar no cosmos. Ela nos ensina como os movimentos celestes influenciam nossa vida, nossa personalidade e nossos caminhos. Nesta fase de mudanças, a compreensão da Astrologia serve como uma bússola integrativa, orientando-nos através dos desafios e oportunidades que emergem em tempos de grande transformação.</p>
                    <p>Como estamos em um momento de profusão tecnológica, isto nos permite processar e compreender enormes quantidades de informações, revelando padrões e insights que antes estavam além de nosso alcance. Tudo isso pode nos ajudar ainda mais a navegar pela complexidade do mundo moderno e seus desafios diários.</p>
                    <p>A configuração astrológica atual está correspondendo a todo tipo de revolução tecnológica e promete trazer profundas transformações sociais. Esta correspondência reflete diretamente na fusão do antigo com o novo, do espiritual com o tecnológico, do Ser humano com a máquina e das novas descobertas do cosmos, para que possamos cada vez mais entender que embora possamos parecer pequenos e isolados, estamos totalmente interligados ao Todo.</p>
                    <p>E tudo isto é fascinante!</p>
                `
            }
        }
    },

    history: {
        newConversation: 'Nova conversa',

        goBack: 'Voltar ao Orbia',

        question: {
            readAll: 'Ler tudo',
            close: 'Fechar',
            dateFormat: 'DD/MM/YYYY - HH:mm',

            types: {
                subscription: 'Assinatura',
                single: 'Avulsa',
                welcome: 'Boas vindas'
            }
        },

        noQuestion: {
            bubble: 'Você ainda não fez nenhuma pergunta. Me pergunte qualquer coisa sobre o seu mapa astral, ou use uma das minhas sugestões para começar 😉',
            talkToOrbia: 'Conversar com o Orbia'
        },

        conversationButton: 'Histórico de Perguntas',

        deleteModal: {
            cancelButton: 'Cancelar',
            title: 'Excluir conversa?',
            confirmButton: 'Confirmar',
            warning:
                'Ao confirmar, todo o histórico desta conversa será apagado permanentemente. Esta ação não pode ser desfeita.',
            errorMessage:
                'Ocorreu um erro ao tentar excluir a conversa. Pedimos desculpas pelo inconveniente. Por favor, tente novamente em instantes ou mais tarde.'
        }
    },

    cta: {
        button: 'Conversar',
        title: 'O Orbia chegou!',
        description: 'Tire dúvidas sobre seu mapa astral com o nosso assistente, gratuitamente!'
    },

    walletInfo: {
        base: 'Seu saldo atual é: ',
        template: '{first} e {second}',
        total: 'Você tem {amount} perguntas.',
        details: 'Ver detalhes',

        avatar: {
            nonSubscriber:
                'Você já usou todas as perguntas de boas vindas. 😕\nAdquira perguntas avulsas ou veja nossos planos Premium. ⭐️',
            subscriber:
                'Você já usou as {renovationAmount} perguntas do mês. Elas estarão disponíveis novamente em {renovationDate} ⏳\nSe precisar de mim antes, você pode adquirir perguntas avulsas!💡'
        },

        subscription: {
            typeName: 'Assinatura',
            singular: 'uma pergunta da sua assinatura, com renovação em {renovationDate}',
            plural: '{amount} perguntas da sua assinatura, que se renovarão em {renovationDate}'
        },

        welcome: {
            typeName: 'Boas vindas',
            singular: '1 pergunta de boas-vindas',
            plural: '{amount} perguntas de boas-vindas'
        },

        ots: {
            typeName: 'Avulsa',
            singular: '1 pergunta avulsa',
            plural: '{amount} perguntas avulsas'
        }
    },

    ots: {
        premiumDiscount: 'Assinantes Astrolink Premium tem 30% de desconto para compras avulsas!',
        otsNeverExpire: 'Perguntas avulsas nunca expiram e ficam sempre disponíveis no seu histórico!',
        subscribeForMore:
            'Ou tenha {renovationAmount} perguntas por mês e outros benefícios com o <a href="{subscribeUrl}">Astrolink Premium</a> por {subscriptionPrice}!',

        title: {
            subscriber: 'precisa de mais perguntas?',
            nonSubscriber: 'Não fique sem o orbia!'
        },

        renovationText: {
            main: 'Seu plano premium dá direito a {amount} perguntas por mês. Você também pode',
            link: 'adquirir perguntas avulsas!'
        },

        selector: {
            questions: '{amount} perguntas',
            buyFor: 'comprar por',
            discount: 'de {price} por',
            mostPopular: 'Mais popular',
            off: '{amount}% off',

            payWith: {
                card: 'Comprar com Cartão',
                pix: 'Comprar com PIX'
            }
        },

        modalTitle: 'Comprar perguntas avulsas'
    },

    menuOptions: {
        title: 'Opções',
        orbiaFeedback: 'Avaliar o Orbia',
        deleteHistory: 'Excluir Historico',
        howDidWork: 'Como o Orbia Funciona?'
    },

    hiddenTemplates: {
        tarot: `
            Jogo de Tarot: {gameName}
            Cartas sorteadas: {cards}
            Minha dúvida:
        `
    },

    tarot: {
        navigation: {
            talkWithAI: 'Conversar com a IA do Astrolink',
            backToTarot: 'Voltar ao Tarot'
        }
    },


    frustation: {
        a: {
            title: 'Tenha perguntas ilimitadas no Orbia com o Astrolink Premium ✨',
            intro: 'Converse com um assistente que conhece o seu mapa astral e te acompanha em cada fase da vida.',
            description: 'No Astrolink Premium você terá a experiência completa: <b>perguntas ilimitadas</b> no assistente astrológico e acesso a outras <b>ferramentas exclusivas</b>.',
            features: {
                horoscope: 'Horóscopo Futuro',
                extrachart: 'Mapa Astral e Mapas Extras',
                biorhythm: 'Biorritmo: seus Ciclos Vitais',
                synastry: 'Compatibilidade Astrológica',
                lunarcycle: 'Ciclo Lunar e Nodos Lunares',
                tarot: 'Tarot Tradicional e do Amor'
            }
        },
        b: {
            questionsLimit: 'Limite de 2 perguntas grátis atingido',
            title: 'Gostou do Orbia? Não precisa parar por aqui! ✨',
            description: 'Com o <b>Astrolink Premium</b> você vai muito além: conversas ilimitadas, mapa astral completo, mapas extras, tarot e compatibilidade astrológica, tudo em um só lugar.',
            close: 'Fechar'
        }
    },

    clipboardAppend: ' - Veja mais em {route}'
};
